export default __webpack_public_path__ + "a531e7759e7f29f171bcc296440b856d.png";